import type { FaireProductEntity } from "../../entity_types/product";

export const p_6jzv4yzgj8: FaireProductEntity = {
  token: "p_6jzv4yzgj8",
  type: "product",
  name: "STAY LOUD • GRAPHIC BAMBOO FLEECE HOODIE",
  brandToken: "b_e267vpec48",
  brandName: "Smiley Daze",
  imageUrl:
    "https://cdn.faire.com/fastly/ced1ae26f9f70c4ca8625142567d18689f8883af59854799656cf8798bdf8ff8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/969dca37d459308758d1530a17734e1b52f2c5cf6cc4397e7383aa58c634f536.jpeg",
    "https://cdn.faire.com/fastly/810678528c6a07d94cbcb20f0fcfc9332bbfad8116539c7c25f8a616d4c9a5c8.jpeg",
    "https://cdn.faire.com/fastly/e1d31a659d882d995c148287e08eecccb559137b10ea9a59d1a45043b14ae827.jpeg",
    "https://cdn.faire.com/fastly/b5b04bd0f7b1eeb50b48b9b54feeacbdbbfee1732eff381b59bf3cdd94540ec0.jpeg",
    "https://cdn.faire.com/fastly/c4863311d14aecfd02a6198afecd3b4a4948bb8713053993a30b4ce96dc00a1d.jpeg",
    "https://cdn.faire.com/fastly/d0c19c5c6e54d3f12ea5f6a1bcd933ddfbe1765b9c6ef2461e79ce93d523703a.jpeg",
    "https://cdn.faire.com/fastly/65dbd45f08dfd6169432f0b6f62552f586ee7e383f5d02a64056f8e200ce13d9.jpeg",
  ],
  priceDollars: 24,
  description:
    "For the kids who don’t whisper, don’t blend in, and don’t back down.\n\nThe Stay Loud Hoodie is crafted from ultra-soft bamboo fleece with a relaxed oversized fit made for everyday chaos. The bold neon green base paired with our signature graphic brings the perfect mix of comfort and confidence.\n\nSoft enough for all-day wear. Loud enough to stand out.\n\nFit\n\nDesigned with a cozy oversized silhouette.\n\nWe recommend ordering your child’s true size — no need to size up.\n\nFabric\n\n• Bamboo fleece blend\n\n• Buttery-soft interior\n\n• Breathable + flexible\n\n• Midweight — perfect for year-round wear \n\nDetails\n\n• Oversized streetwear fit\n\n• Front kangaroo pocket\n\n• Ribbed cuffs + hem for structure\n\n• Statement front + back graphic\n\n\n\nBuilt for big personalities, fast feet, and fearless energy.\n",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:27.385Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
